import * as Yup from 'yup';

import { addressValidation } from '../../AccountForms/CreateAccountForm/createAccountForm.validation';

export const updateShippingLocationValidation = Yup.object({
  shippingLocationAddress: addressValidation
});
